$(document).ready(function() {

    $('.home-cta').slick({

        dots: false,
        arrows:false,
        autoplay:true,
        slidesToShow: 3,
        slidesToScroll: 1,
        speed: 200,
          responsive: [
            {
              breakpoint: 481,
              settings: "unslick"
            },

            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                fade: true,
                speed: 200,
                slidesToScroll: 1
              }

            }

          ]

    });


});
